import {storageTypes} from "../types/storageTypes";

/**
 * Удаляет указанные ключи из localStorage или sessionStorage.
 *
 * Эта функция принимает массив ключей и удаляет соответствующие элементы
 * из указанного хранилища браузера (localStorage или sessionStorage).
 * Если входной параметр не является массивом или является пустым, функция ничего не делает.
 * Если тип хранилища не указан или некорректен, используется localStorage по умолчанию.
 *
 * @param {Array<string>} cachesToClean - Массив ключей, которые нужно удалить из хранилища.
 * @param {string} [storageType='localStorage'] - Тип хранилища, из которого нужно удалить ключи ('localStorage' или 'sessionStorage').
 */
export const cacheCleaner = (cachesToClean, storageType = storageTypes.LOCAL_STORAGE) => {

    if (!cachesToClean || !Array.isArray(cachesToClean) || !cachesToClean.length) {
        return;
    }

    const storage = storageType === storageTypes.SESSION_STORAGE ? sessionStorage : localStorage;

    cachesToClean.forEach((key) => {
        storage.removeItem(key);
    });
};